/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Study_Field_PlaceholderInputs */

const en_candidate_profile_study_field_placeholder = /** @type {(inputs: Candidate_Profile_Study_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Computer Science, Business Administration`)
};

const de_candidate_profile_study_field_placeholder = /** @type {(inputs: Candidate_Profile_Study_Field_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Informatik, Betriebswirtschaftslehre`)
};

/**
* | output |
* | --- |
* | "e.g., Computer Science, Business Administration" |
*
* @param {Candidate_Profile_Study_Field_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_study_field_placeholder = /** @type {((inputs?: Candidate_Profile_Study_Field_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Study_Field_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_study_field_placeholder(inputs)
	return en_candidate_profile_study_field_placeholder(inputs)
});